import * as ActionTypes from 'actions/Member';
import * as AuthActionTypes from 'actions/Auth';
import { get } from 'lodash';

const initialState = {
  members: [],
  activeMembers: [],
  inactiveMembers: [],
  roles: [],
  membersListPage: 0,
  activeMembersPage: 0,
  inactiveMembersPage: 0,
  tableFilter: {},
  tableSorting: {},
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case AuthActionTypes.LOGOUT.SUCCESS:
      return { ...initialState };
    case ActionTypes.SET_MEMBER_TABLE_FILTER:
      return { ...state, tableFilter: action.payload };
    case ActionTypes.SET_MEMBER_TABLE_SORTING:
      return { ...state, tableSorting: action.payload };
    case ActionTypes.GET_MEMBERS.SUCCESS:
      return {
        ...state,
        members: get(action.payload, 'content'),
        membersPage: get(action, 'payload.currentPage', 0),
        membersPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_ACTIVE_MEMBERS.SUCCESS:
      return {
        ...state,
        activeMembers: get(action.payload, 'content'),
        activeMembersPage: get(action, 'payload.currentPage', 0),
        activeMembersPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_INACTIVE_MEMBERS.SUCCESS:
      return {
        ...state,
        inactiveMembers: get(action.payload, 'content'),
        inactiveMembersPage: get(action, 'payload.currentPage', 0),
        inactiveMembersPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_MEMBER.SUCCESS:
      return {
        ...state,
        member: action.payload,
      };
    case ActionTypes.GET_ROLES.SUCCESS:
      return {
        ...state,
        roles: action.payload,
      };
    default:
      return state;
  }
}
